import React from 'react'
import { IProps as IMagicLine, MagicLine } from 'marketing-site/src/library/components/MagicLine'

import { IMagicLine as IContentfulMagicLine } from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export const ContentfulMagicLine = (magicLine: IContentfulMagicLine) => (
  <EntryMarker entry={magicLine}>
    {() => <MagicLine {...transformMagicLine(magicLine)} />}
  </EntryMarker>
)

export function transformMagicLine({
  fields: { texture, ...fields },
}: IContentfulMagicLine): IMagicLine {
  return {
    ...fields,
    texture: texture as IMagicLine['texture'],
  }
}
